import utils from './utils'


const state = () => ({
  /**
   * レスポンシブに PC/Mobile の表示が切り替わる Viewport 幅（これ以下のとき Mobile 向け表示）
   */
  breakPointWidth: 768,

  /**
   * サンプル
   */
  fooBarProp: '',
})


const getters = {
}


const actions = {
  /**
   * @param {Context} context    Vuex コンテキスト { state, rootState, getters, rootGetters, dispatch, commit }
   */
  onFooBar ({ commit }) {
    commit('update', { fooBarProp: 'hoge' })
  },
}


const mutations = {
  /** @see utils.mutations.update */
  update (state, payload) {
    utils.mutations.update(state, payload)
  },

  /** @see utils.mutations.reset */
  reset (_state_, payload) {
    utils.mutations.reset(_state_, { ...payload, origin: state() })
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
